"use client";
import React, { useEffect, useState } from "react";
import "./page.css";
import Template4 from "../../../Components/Templates/Template4";
import Download from "../../../Components/Download/Download";
import Section from "../../../Components/Section/Section";
import { useParams } from "next/navigation";
import { _eventBus } from "../../../core/events/EventBus";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { mainAppStartupFlowExecute } from "../../../Flows/MainAppPage/MainAppStartFlow";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICMSNewsTypes } from "../../../Orchestrator/Types/Interface/ICMSNews";
import { useOnLanguageChange } from "../../../Components/CustomHooks/useOnLanguageChange";
import { useIntl } from "react-intl";
import { cmsImageUrl } from "../../../Lib/Utils/cmsImage";

const NewsDetailPage = () => {
  const [initialLoadFinished, setInitialLoadFinished] = useState(false);
  const intl = useIntl();
  const [newsDetail] = useRecState<ICMSNewsTypes>("newsDetailResponseAtom");
  const params = useParams();
  const slug = params.news_slug;

  useOnLanguageChange(() => {
    _eventBus.emit({
      eventName: evtTree.News.Details.Get,
      data: {
        slug,
      },
    });
  });

  useEffect(() => {
    return () => {
      _eventBus.emit({
        eventName: "FLOW_CLOSE",
        data: `NewsDetailFlow`,
      });
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoadFinished(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      mainAppStartupFlowExecute("NewsDetailFlow");
    }, 100);
    if (slug) {
      const timer = setTimeout(() => {
        _eventBus.emit({
          eventName: evtTree.News.Details.Get,
          data: {
            slug,
          },
        });
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [slug]);
  return (
    <div>
      {!newsDetail ? (
        initialLoadFinished ? (
          <div className="text-center p-12">
            {intl.formatMessage({ id: "noData" })}
          </div>
        ) : null
      ) : (
        <Template4
          title={newsDetail.title}
          image={cmsImageUrl(newsDetail.image)}
          subtitle={newsDetail.description}
          content={newsDetail.article_content}
        />
      )}

      <Section type="trust_builder offers_trust_builder">
        <div className="container">
          <Download />
        </div>
      </Section>
    </div>
  );
};

export default NewsDetailPage;
